
















































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { OsusumeService } from "../services/Osusume.service";
import { BuhinsService } from "../services/Buhins.service";
import { OsusumeSeibiService } from "../services/OsusumeSeibi.service";
import InputNumber from "@/views/components/input/InputNumber.vue";
import { Utils } from "@/services/utils";
import { CommonService } from "@/services/Common.service";
import vuedraggable from "vuedraggable";
import InputString from '@/views/components/input/InputString.vue';
import { SeibiExtremeService } from "@/services/SeibiExtreme.service";
import { SeibiService } from "@/services/Seibi.service";

@Component({
  components: {
    InputNumber,
    draggable: vuedraggable
    , InputString
  }
})
export default class OsusumeCategory extends Vue {
  @Prop({ default: "" })
  title: string;
  loading: boolean = true;
  listSeibi: any = [];
  listSelected: any[] = [];
  listSelectedDisplayOrder: any[] = [];
  listManualSeibi: any = [];
  seibiData: any = [];
  listSeibiCurrentCate: any = [];
  titles: any = [];
  cates: any = [];
  displayDialog: boolean = false;
  dialogTitle: string = "";
  cateName: string = "";
  kingakuZn: any = 0;
  kingakuZk: any = 0;
  isEdit: boolean = false;
  editIndex: number = -1;
  activeTab: string = "";
  activeTabIndex: number = 0;
  osusumeService: OsusumeService = new OsusumeService();
  buhinService: BuhinsService = new BuhinsService();
  osusumeSeibiService: OsusumeSeibiService = new OsusumeSeibiService();
  commonService = new CommonService();
  seibiExtremeService: SeibiExtremeService = new SeibiExtremeService();
  seibiService = new SeibiService();
  util: Utils = new Utils();
  seibiNm: string = "";
  chkAllSeibi: boolean = false;
  keywordSearch: string = "";
  chkAllSeibiManual: boolean = false;
  taxRate: number = 100;
  shouhizeiMarumeKbn: number = 0;
  environment: any;
  displayBuhinDialog: boolean = false;
  listBuhinEdit: any = [];
  dialogBuhinTitle: string = "";
  seibiIdEdit: number | null = null;
  tempManualSeibiNm: string = "";
  drag: boolean = false;
  kingakuFlg: boolean = false;
  seibiEdit: any = null;
  showConfirmDelete = false;
  idDelete = -1;
  tab: string = "";
  seibiSbt: string = "0";
  extremeWorkList = [];
  expSeibiData: any = [];

  $refs!: {
    inputCateName: InputString;
  };

  created() {
    this.getCategory(0);
    this.osusumeSeibiService.getSeibiRecommendSeibi().then((res: any) => {
      this.loading = false;
      if (res) {
        this.seibiData = res;
        this.listSeibi = res.map((e: any) => {
          return {
            sknInspectSeibiDetailId: e.id,
            sknInspectSeibiDetailNm: e.sknInspectSeibiTitle
            , disabled: e.disabled
/** 2022-04-08 sh #7799(BQR955) add workCd. [START] */
            , key: e.id
/** 2022-04-08 sh #7799(BQR955) add workCd. [END] */
          };
        });
      }
    });
    this.getMarumeKbn();
  }

  async getMarumeKbn() {
    this.environment = await this.commonService.getEnvironment();
    if (this.environment) {
      this.shouhizeiMarumeKbn = this.environment.shouhizeiMarumeKbn;
    }
  }

  async getCategory(activeIndex: number) {
    /** 2022-07-05 sh #7958(BQR1003) add reset and loading. [START] */
    this.$set(this, "loading", true);
    /** 2022-07-05 sh #7958(BQR1003) add reset and loading. [END] */
    const response = await this.osusumeService.getCategory();
    if (response && response.length > 0) {
      let cates = response.map((e: any) => {
        return {
          seibiList: e.seibiList,
          seibiManualList: e.seibiManualList.map((item: any) => {
            return {
              ...item,
              isEdit: false
            };
          }),
          id: e.sknRecommendInspectCategoryId,
          recommendCategoryName: e.sknRecommendInspectCategoryNm
          , kingakuZk: e.kingakuZk
          , kingakuZn: e.kingakuZn
        };
      });
      this.$set(this, "cates", cates);
      this.$set(this, "titles", [
        "作業指示",
        this.cates[activeIndex].recommendCategoryName
      ]);
      this.$set(this, "activeTab", activeIndex.toString());
      /** 2022-07-05 sh #7958(BQR1003) add reset and loading. [START] */
      this.$set(this, "loading", false);
      /** 2022-07-05 sh #7958(BQR1003) add reset and loading. [END] */
      this.getExtremeWorks();
    }
  }

  onTabClick(tab: any) {
    this.activeTabIndex = +tab.paneName;
    this.titles = [
      "作業指示",
      this.cates[this.activeTabIndex].recommendCategoryName
    ];
    this.kingakuFlg = false;
    if ((this.cates[this.activeTabIndex].kingakuZk && this.cates[this.activeTabIndex].kingakuZk > 0)
      || (this.cates[this.activeTabIndex].kingakuZn && this.cates[this.activeTabIndex].kingakuZn > 0)) {
      this.kingakuFlg = true;
    }
    this.setSeibiList();
  }

  setSeibiList() {
    this.$set(
      this,
      "listSeibiCurrentCate",
      this.cates[this.activeTabIndex].seibiList
    );
    const cloneListSeibiCurrentCate = this.util.deepCopy(this.listSeibiCurrentCate);
    const listSelected: any = [];
    this.listSelectedDisplayOrder = [];
    cloneListSeibiCurrentCate.forEach(({ displayOrder, ...rest }: any) => {
      listSelected.push({ ...rest});
      this.listSelectedDisplayOrder.push({
        id: rest.sknInspectSeibiDetailId,
        displayOrder
/** 2022-04-08 sh #7799(BQR955) add workCd. [START] */
        , isExtreme: rest.isExtreme
        , key: rest.isExtreme + '-' + rest.sknInspectSeibiDetailId
/** 2022-04-08 sh #7799(BQR955) add workCd. [END] */
      });
    });
    this.$set(this, "listSelected", listSelected);
    this.$set(
      this,
      "listManualSeibi",
      this.cates[this.activeTabIndex].seibiManualList
    );
  }

  get allSelectedSeibi() {
    let originalSeibiIndex = 0;
    let originalManualSeibiIndex = 0;
    const listSelectedWithDisplayOrder = this.listSelected.map((item: any, index: number) => {
      return {
        ...item,
        /** 2023-02-21 sh #8201(BQR1086) modify compare condition. [START] */
        // displayOrder: this.listSelectedDisplayOrder[index].displayOrder || item.displayOrder
        displayOrder: this.checkDisplayOrder(index, item)
        /** 2023-02-21 sh #8201(BQR1086) modify compare condition. [END] */
        , isExtreme: item.isExtreme
      };
    });
    return [ ...listSelectedWithDisplayOrder, ...this.listManualSeibi ]
      .sort((a: any, b: any) => parseInt(a.displayOrder, 10) - parseInt(b.displayOrder, 10))
      .map((item: any, index: number) => {
        return {
          id: item.sknInspectSeibiDetailId || item.id,
          type: item.sknInspectSeibiDetailId ? "normal" : "manual",
          name: item.sknInspectSeibiDetailNm || item.seibiNm,
          isShow: !!item.sknInspectSeibiDetailId || item.isShow == 1 ? 1 : 0,
          originalIndex: item.sknInspectSeibiDetailId ? originalSeibiIndex++ : originalManualSeibiIndex++,
          displayOrder: index
          , isExtreme: item.isExtreme
        };
      });
  }

  /** 2023-02-21 sh #8201(BQR1086) modify compare condition. [START] */
  checkDisplayOrder(index: number, item: any) {
    if (this.listSelectedDisplayOrder && this.listSelectedDisplayOrder.length > 0
      && index < this.listSelectedDisplayOrder.length
      && this.listSelectedDisplayOrder[index].hasOwnProperty("displayOrder")
    ) {
      return this.listSelectedDisplayOrder[index].displayOrder;
    }
    return item.hasOwnProperty("displayOrder") ? item.displayOrder : this.listSelectedDisplayOrder.length;
  }
  /** 2023-02-21 sh #8201(BQR1086) modify compare condition. [END] */

  async onRemoveTab() {
    const { result, error } = await this.osusumeService.deleteCategory(this.idDelete);
    if (result && result.status == 200) {
      const index = this.cates.findIndex((cate: any) => cate.id == this.tab);
      this.cates.splice(index, 1);
      this.showConfirmDelete = false;
    } else {
      this.onError(error);
    }
  }

  editCate(index: number, e: any) {
    e.stopPropagation();
    this.displayDialog = true;
    this.isEdit = true;
    this.editIndex = index;
    this.cateName = this.cates[index].recommendCategoryName;
    this.kingakuZn = this.cates[index].kingakuZn;
    this.kingakuZk = this.cates[index].kingakuZk;
    this.dialogTitle = "Edit";
  }

  onAddCate() {
    this.displayDialog = true;
    this.cateName = "";
    this.kingakuZn = 0;
    this.kingakuZk = 0;
    this.isEdit = false;
    this.dialogTitle = "Add";
  }

  get disableSaveCate() {
    return this.cateName == "";
  }

  onError(error: any) {
    let msg = "error";
    if (error.data && error.data.rsltComment) {
      msg = error.data.rsltComment;
    } else if (error.statusText) {
      msg = error.statusText;
    }
    this.$message({
      message: msg,
      type: "error"
    });
  }

  async onSaveCate() {
    if (this.$refs.inputCateName.validate()) {
    const data = { recommendCategoryName: this.cateName, kingakuZn: this.kingakuZn, kingakuZk: this.kingakuZk };
    if (this.isEdit) {
      let objSave: any = {
        id: this.cates[this.editIndex].id,
        ...data
      };
      const { result, error } = await this.osusumeService.edtCategory(objSave);
      if (result && result.status == 200) {
        this.$set(this.cates, this.editIndex, {
          ...this.cates[this.editIndex],
          ...data,
          seibiList: [],
          seibiManualList: []
        });
      } else {
        this.onError(error);
      }
    } else {
      const { result, error } = await this.osusumeService.addCategory(data);
      if (result && result.status == 200) {
        this.getCategory(this.activeTabIndex);
      } else {
        this.onError(error);
      }
    }
    this.displayDialog = false;
    }
  }

  async onSave(isDelete: boolean = false) {
    /** 2022-07-05 sh #7958(BQR1003) add reset and loading. [START] */
    this.$set(this, "loading", true);
    /** 2022-07-05 sh #7958(BQR1003) add reset and loading. [END] */
    const normalSeibi: any = [];
    const manualSeibi: any = [];
    this.allSelectedSeibi.forEach((item: any) => {
      if (item.type === "normal") {
        normalSeibi.push({
          sknInspectSeibiDetailId: item.id,
          displayOrder: item.displayOrder
          , isExtreme: item.isExtreme
        });
      } else {
        manualSeibi.push({
          ...this.listManualSeibi[item.originalIndex],
          displayOrder: item.displayOrder
          , isExtreme: 0
        });
      }
    });
    let listId = normalSeibi.map((e: any) => {
      return {
        sknInspectSeibiDetailId: e.sknInspectSeibiDetailId,
        displayOrder: e.displayOrder
        , isExtreme: e.isExtreme
      };
    });
    let listIdSaved = this.listSeibiCurrentCate.map(
      (e: any) => e.sknInspectSeibiDetailId
    );
    let listSeibi = this.listSeibiCurrentCate.filter(
      (e: any) => listId.indexOf(e.sknInspectSeibiDetailId) == -1
    );
    listSeibi = listSeibi.map((e: any) => {
      return { seibiId: e.sknInspectSeibiDetailId, isDelete: 1 };
    });
    let listSeibiAdd = listId
      .filter((id: number) => listIdSaved.indexOf(id) == -1)
      .map((e: any) => {
        return {
          seibiId: e.sknInspectSeibiDetailId,
          isDelete: 0,
          displayOrder: e.displayOrder
          , isExtreme: e.isExtreme
        };
      });
    const seibiManualList = manualSeibi
      .filter((e: any) => e.seibiNm != "")
      .map(({ isEdit, ...rest }: any) => {
        return { ...rest };
      });
    let data = {
      id: this.cates[this.activeTabIndex].id,
      seibiList: [...listSeibi, ...listSeibiAdd],
      seibiManualList
    };
    const { result, error } = await this.osusumeService.saveSeibiList(data);
    /** 2022-07-05 sh #7958(BQR1003) add reset and loading. [START] */
    this.$set(this, "loading", false);
    /** 2022-07-05 sh #7958(BQR1003) add reset and loading. [END] */
    if (result && result.status == 200) {
      if (isDelete) {
        this.$message({
          message: "Deleted!",
          type: "success"
        });
      } else {
        this.$message({
          message: "saved!",
          type: "success"
        });
      }
      /** 2022-07-05 sh #7958(BQR1003) add reset and loading. [START] */
      this.$set(this, "listSelected"          , []);
      this.$set(this, "listManualSeibi"       , []);
      this.$set(this, "listSeibiCurrentCate"  , []);
      /** 2022-07-05 sh #7958(BQR1003) add reset and loading. [END] */
      this.getCategory(this.activeTabIndex);
    } else {
      this.onError(error);
    }
  }

  get listSeibiDisplay() {
    let res: any = [];
    if (this.seibiSbt === '0') {
    if (this.listSeibi.length > 0) {
      res = this.listSeibi
        .filter(
          (item: any) =>
            JSON.stringify(item)
              .toLowerCase()
              .indexOf(this.keywordSearch.toLowerCase()) > -1
        )
        .map(({ displayOrder, ...rest }: any) => {
          return { isExtreme: 0, ...rest };
        });
      return res;
    }
    } else if (this.seibiSbt === '1') {
      if (this.extremeWorkList.length > 0) {
        res = this.extremeWorkList
          .filter(
            (item: any) =>
              JSON.stringify(item)
                .toLowerCase()
                .indexOf(this.keywordSearch.toLowerCase()) > -1
          )
          .map(({ displayOrder, ...rest }: any) => {
            return { isExtreme: 1, ...rest };
          });
        return res;
      }
    }
    return res;
  }

  onClickChkAll() {
    if (this.chkAllSeibi) {
      this.listSeibiCurrentCate = this.listSeibi;
    } else {
      this.listSeibiCurrentCate = [];
    }
  }

  onClickChkAllManual() {
    this.listManualSeibi.forEach((e: any) => {
      e.isShow = this.chkAllSeibiManual ? 1 : 0;
    });
  }

  onAddSeibiManual() {
    if (this.seibiNm) {
      this.listManualSeibi.push({
        isShow: 1,
        seibiNm: this.seibiNm,
        kouchinZn: 0,
        kouchinZk: 0,
        buhinZn: 0,
        buhinZk: 0,
        buhinList: [],
        isEdit: false,
        displayOrder: [...this.listSelected, ...this.listManualSeibi].length + 1
      });
      this.seibiNm = "";
    }
  }

  onListSelectedChecked(seibi: any) {
    const index = this.listSelected.findIndex((item: any) =>
      (item.sknInspectSeibiDetailId === seibi.sknInspectSeibiDetailId && item.isExtreme === 0)
    );
    if (index > -1) {
      // Case: Checked - append as last item
      this.listSelectedDisplayOrder.push({
        id: seibi.sknInspectSeibiDetailId,
        displayOrder: [...this.listSelected, ...this.listManualSeibi].length
        , isExtreme: 0
      });
    } else {
      // Case: Unchecked - remove unchecked item and shift every items behind the removed index up for 1 index
      const delIndex = this.listSelectedDisplayOrder.findIndex((item: any) =>
        (item.id === seibi.sknInspectSeibiDetailId && item.isExtreme === 0)
      );
      const delItem = this.listSelectedDisplayOrder.splice(delIndex, 1);
      this.updateDisplayOrder(delItem[0].displayOrder);
    }
  }

  onManualSebiChecked(seibi: any) {
    if (seibi.isShow) {
      // Case: Checked - append as last item
      seibi.displayOrder = [...this.listSelected, ...this.listManualSeibi].length;
    } else {
      // Case: Unchecked - shift every items behind and included the hidden item up for 1 index,
      // then move the hidden index to last item
      this.updateDisplayOrder(seibi.displayOrder);
      seibi.displayOrder = [...this.listSelected, ...this.listManualSeibi].length - 1;
    }
  }

  updateDisplayOrder(displayOrder: number) {
    const shiftAt = this.allSelectedSeibi.findIndex((item: any) => item.displayOrder === displayOrder);
    if (shiftAt > -1) {
      for (let i = shiftAt; i < this.allSelectedSeibi.length; i++) {
        const item = this.allSelectedSeibi[i];
        if (item.type === "normal") {
          this.listSelectedDisplayOrder[item.originalIndex].displayOrder--;
        } else {
          this.listManualSeibi[item.originalIndex].displayOrder--;
        }
      }
    }
  }

  onEditManualSeibiNm(manualSeibi: any) {
    this.tempManualSeibiNm = manualSeibi.seibiNm;
    manualSeibi.isEdit = true;
  }

  onCancelEditManualSeibiNm(manualSeibi: any) {
    this.tempManualSeibiNm = "";
    manualSeibi.isEdit = false;
  }

  renameManualSeibi(manualSeibi: any) {
    if (this.tempManualSeibiNm) {
      manualSeibi.seibiNm = this.tempManualSeibiNm;
    }
    manualSeibi.isEdit = false;
  }

  onDragEnd(event: any) {
    this.drag = false;
    const cloneArray = this.util.deepCopy(this.allSelectedSeibi);
    const cloneListSelected = this.util.deepCopy(this.listSelected);
    const cloneListManualSeibi = this.util.deepCopy(this.listManualSeibi);
    this.listSelected = [];
    this.listSelectedDisplayOrder = [];
    this.listManualSeibi = [];
    let displayOrder = 0;
    cloneArray.forEach((item: any) => {
      if (item.type === "normal") {
        this.listSelected.push({
          ...cloneListSelected[item.originalIndex]
        });
        this.listSelectedDisplayOrder.push({
          id: item.sknInspectSeibiDetailId,
          displayOrder
          , isExtreme: 0
        });
      } else {
        this.listManualSeibi.push({
          ...cloneListManualSeibi[item.originalIndex],
          displayOrder
        });
      }
      displayOrder++;
    });
  }

  async setPrice(item: any, key: string, isZk: boolean) {
    const keySrc = isZk ? "Zk" : "Zn";
    const keyPrice = isZk ? "Zn" : "Zk";
    let price = 0;
    if (isZk) {
      price = await this.getZn(item[key + keySrc]);
    } else {
      price = await this.getZk(item[key + keySrc]);
    }
    item[key + keyPrice] = price;
  }

  async getZn(zk: number) {
    let zn = 0;
    if (zk) {
      zn = await this.commonService.calcZeinuki(
        zk,
        this.taxRate,
        this.shouhizeiMarumeKbn
      );
    }
    return zn;
  }

  async getZk(zn: number) {
    let zk = 0;
    if (zn) {
      zk = await this.commonService.calcZeikomi(
        zn,
        this.taxRate,
        this.shouhizeiMarumeKbn
      );
    }
    return zk;
  }

  onEditBuhin(seibi: any) {
    this.seibiEdit = seibi;
    this.displayBuhinDialog = true;
    this.listBuhinEdit = seibi.buhinList;
    this.dialogBuhinTitle = seibi.seibiNm;
    this.seibiIdEdit = seibi.id;
    if (this.listBuhinEdit.length == 0) {
      this.onAddBuhin();
    }
  }

  onAddBuhin() {
    this.listBuhinEdit.push({
      sknOsusumeInspectSeibiId: this.seibiIdEdit,
      buhinNm: "",
      buhinZn: 0,
      buhinZk: 0
    });
  }

  onDeleteBuhin(index: number) {
    const buhin = this.listBuhinEdit.splice(index, 1);
    if (buhin[0].id) {
      this.osusumeService.deleteBuhin(buhin[0].id);
    }
  }

  onDeleteManualSeibi(index: number) {
    const seibi = this.listManualSeibi.splice(index, 1);
    if (seibi[0].id) {
      this.osusumeService.deleteSeibi(seibi[0].id);
    }
  }

  onDeleteSeibi(index: number) {
    const seibi: any = this.listSelected.splice(index, 1);
    if (this.listSeibiCurrentCate.length > 0) {
      const listId = this.listSeibiCurrentCate.map(
        (e: any) => e.sknInspectSeibiDetailId
      );
      const delIndex = this.listSeibiCurrentCate.findIndex(
        (e: any) => e.sknInspectSeibiDetailId == seibi[0].sknInspectSeibiDetailId
      );
      if (delIndex > -1) {
        this.onSave(true);
      }
    }
  }
  async setKingakuZn() {
    if (this.kingakuZk) {
    this.kingakuZn = await this.getZn(this.kingakuZk);
    } else {
      this.kingakuZn = '';
    }
  }
  async setKingakuZk() {
    if (this.kingakuZn) {
    this.kingakuZk = await this.getZk(this.kingakuZn);
    } else {
      this.kingakuZk = '';
    }
  }

  onCloseBuhinDialog() {
    this.displayBuhinDialog = false;
    this.seibiEdit.buhinList = this.seibiEdit.buhinList.filter(
      (e: any) => e.buhinNm
    );
  }

  onConfirmDelete(tab: string) {
    this.tab = tab;
    const id: number = +this.cates[tab].id;
    this.idDelete = id;
    this.showConfirmDelete = true;
  }

  async getExtremeWorks() {
    /** 2022-07-05 sh #7958(BQR1003) add reset and loading. [START] */
    this.$set(this, "loading", true);
    /** 2022-07-05 sh #7958(BQR1003) add reset and loading. [END] */
    const { result } = await this.osusumeSeibiService.getRecommendExtremeWorks();
    /** 2022-07-05 sh #7958(BQR1003) add reset and loading. [START] */
    this.$set(this, "loading", false);
    /** 2022-07-05 sh #7958(BQR1003) add reset and loading. [END] */
    if (result && result.data) {
      this.expSeibiData = result.data;
      this.extremeWorkList = result.data.map((e: any) => {
          return {
            sknInspectSeibiDetailId: e.id,
            sknInspectSeibiDetailNm: e.workNm
            , disabled: e.disabled
/** 2022-04-08 sh #7799(BQR955) add workCd. [START] */
            , key: e.id + '-' + e.workCd
            , workCd: e.workCd
/** 2022-04-08 sh #7799(BQR955) add workCd. [END] */
          };
        });
      this.setSeibiList();
    }
  }

  onExpListSelectedChecked(seibi: any) {
    if (seibi.sknInspectSeibiDetailId != 0) {
      const index = this.listSelected.findIndex((item: any) =>
        (item.sknInspectSeibiDetailId === seibi.sknInspectSeibiDetailId && item.isExtreme === 1)
      );
      if (index > -1) {
        // Case: Checked - append as last item
        this.listSelectedDisplayOrder.push({
          id: seibi.sknInspectSeibiDetailId,
          displayOrder: [...this.listSelected, ...this.listManualSeibi].length
          , isExtreme: 1
        });
      } else {
        // Case: Unchecked - remove unchecked item and shift every items behind the removed index up for 1 index
        const delIndex = this.listSelectedDisplayOrder.findIndex((item: any) =>
          (item.id === seibi.sknInspectSeibiDetailId && item.isExtreme === 1)
        );
        const delItem = this.listSelectedDisplayOrder.splice(delIndex, 1);
        this.updateDisplayOrder(delItem[0].displayOrder);
      }
    } else {
      this.saveExpSeibi(seibi);
    }
  }

  async saveExpSeibi(seibi: any) {
    let data = this.expSeibiData.filter(
      /** 2023-02-21 sh #8201(BQR1086) modify compare condition. [START] */
      // (e: any) => e.workNm === seibi.sknInspectSeibiDetailNm
      (e: any) => e.workNm === seibi.sknInspectSeibiDetailNm && e.workCd === seibi.workCd
      /** 2023-02-21 sh #8201(BQR1086) modify compare condition. [END] */
    );
    if (data && data.length > 0) {
      let param = {
        workCd: data[0].workCd
        , workNm: data[0].workNm
      };
      this.$set(this, "loading", true);
      const result = await this.seibiService.saveOsusumeMSknExpSeibiDetail(param);
      this.$set(this, "loading", false);
      if (result.status === 200) {
        seibi.sknInspectSeibiDetailId = result.data;
        this.onExpListSelectedChecked(seibi);
      } else {
        this.$message.error("エラー");
      }
    }
  }
  /** 2022-04-08 sh #7799(BQR955) add workCd. [START] */
  /**
   * 選択中のカテゴリにおいて、選択済みかどうかのチェックをする。
   */
  expListSelectedChecked(item: any) {
      const filtered = this.listSelectedDisplayOrder.filter((e: any) =>
          (e.id === item.sknInspectSeibiDetailId && e.isExtreme === 1)
      );
      if (filtered && filtered.length > 0) {
        return true;
      }

      return false;
  }
  /** 2022-04-08 sh #7799(BQR955) add workCd. [END] */
}
